const SYMPATHY_FUNERAL_PRIORITY_PATTERN = /sympath|funeral/i

function hasSympathyFuneralPriority(value: string | null | undefined): boolean {
  // "sympath" intentionally catches both "sympathy" and "sympathies".
  return SYMPATHY_FUNERAL_PRIORITY_PATTERN.test(String(value ?? ''))
}

export function sortSympathyFuneralFirst<T extends { name?: string | null }>(
  items: readonly T[],
  getLabel: (item: T) => string | null | undefined = (item) => item?.name
): T[] {
  return items
    .map((item, index) => ({
      item,
      index,
      isPriority: hasSympathyFuneralPriority(getLabel(item)),
    }))
    .sort((left, right) => {
      if (left.isPriority !== right.isPriority) {
        return left.isPriority ? -1 : 1
      }

      return left.index - right.index
    })
    .map(({ item }) => item)
}
